import {FormSanctionModel} from './FormSanctionModel';

export class FormStupefiantModel {

  nombreControlesPositifsStupefiants36DerniersMois: number;
  dateDernierStupefiant36DerniersMois: string;
  controleStupefiantSuiteA36DerniersMois: string;
  controleStupefiantMethode36DerniersMois: string;
  isRefusTestStupefiant36DerniersMois: string;
  isDelitDeFuiteStupefiant36DerniersMois: string;
  isAnnulationOuSuspensionPermis36DerniersMois: string;
  sanction: FormSanctionModel;

  constructor() {
    this.sanction = new FormSanctionModel();
  }
}
